<template>
<div id="CourseSideBar">
  <Tabs :value="tabValue" ref="tabs" v-model="tabValue">
    <TabPane label="聊天" name="chat" v-if="tabsDisplay.includes('chat') && course.chatGroupOpenFlag">
      <div class="chat-wrap">
        <CourseChatRoom
          class="course-chat-room"
          :msgs="msgs"
          :members="members"
          :topLoad="getHistoryMsgs"
          :bottomLoad="getMembersListLimit"
          :onlineMemberNum="onlineMemberNum"
          :courseId="course.pkid"
          :isManager="isManager"
          @sendMsg="sendMsg"
          @preview="preview"
          @toggleChatRoom="(v) => showChatRoom = v"
          @forbiddenUser="forbidden"
        />
        <CourseChatInput
          class="course-chat-input"
          :imIsConnected="imIsConnected"
          :course="course"
          :msgsNum="msgsNum"
          :showChatRoom="showChatRoom"
          :uploadingImg="uploadingImg"
          @sendMsg="sendMsg"
          @sendGift="sendGift"
          @sendFile="sendFile"
          @toggleChatRoom="(v) => showChatRoom = v"
        />
      </div>
    </TabPane>
    <TabPane label="在线" name="online" v-if="tabsDisplay.includes('online') && course.chatGroupOpenFlag">
      <CourseOnline
        class="course-chat-room"
        :members="members"
        :accounts="accounts"
        :topLoad="getHistoryMsgs"
        :bottomLoad="getMembersListLimit"
        :onlineMemberNum="onlineMemberNum"
        :isManager="isManager"
        @forbiddenUser="forbidden"
        @cancelForbidden="cancelForbidden"
      ></CourseOnline>
    </TabPane>
    <TabPane label="课表" name="curriculum" v-if="tabsDisplay.includes('curriculum')">
      <CourseCurriculum v-if="tabValue === 'curriculum'" :curCourse="course" @changeCourseProps="changeCourseProps"></CourseCurriculum>
    </TabPane>
    <TabPane label="禁言" name="forbidden"  v-if="tabsDisplay.includes('forbidden')&&isManager">
      <CourseMute
        class="course-chat-room"
        :members="muteUserList"
        @cancelForbidden="cancelForbidden"
      ></CourseMute>
    </TabPane>
  </Tabs>
  <viewer ref="imgViewer" :images="imgList" style="display:none" @inited="initViewer">
    <img v-for="(img, idx) in imgList" :key="idx" :src="img">
  </viewer>
  <!-- <div class="preview" v-show="isPreviewShow">
    <div class="close" @click="closePreview"><i class="ibang-close"></i></div>
    <div class="img-wrapper">
      <img :src="previewImage" width="100%">
    </div>
  </div> -->
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dateStringFrom, handleUrlString, throttle } from '@/utils'
import CourseChatInput from './CourseChatInput'
import CourseInfo from './CourseInfo'
import CourseChatRoom from './CourseChatRoom'
import CourseOnline from './CourseOnline'
import CourseMute from './CourseMute'
import CourseCurriculum from './CourseCurriculum'
import chatBus from '@/bus/chat'
import 'viewerjs/dist/viewer.css'
import { component as Viewer } from 'v-viewer'

// 常量定义
const THROTTLEDELAY = 1000
const THROTTLEMAXDELAY = 2000

// 定义组件内全局变量
let chatroomInstance

export default {
  components: {
    CourseChatInput,
    CourseInfo,
    CourseChatRoom,
    CourseOnline,
    CourseCurriculum,
    CourseMute,
    Viewer,
  },
  props: {
    course: {
      type: Object,
    },
    accounts: {
      type: Array,
      default () {
        return []
      },
    },
  },
  mounted () {
    this.tabValue = this.tabsDisplay[0]
  },
  data () {
    return {
      msgsNum: 0,
      msgs: [],
      members: [],
      imIsConnected: false,
      lastEnterTime: 0,
      showChatRoom: false,
      selfInfo: {
        name: '',
        avatar: '',
      },
      sensitive: [], // 敏感词
      isPreviewShow: false,
      previewImage: '',
      isManager: false,
      muteUserList: [],
      tabValue: '',
      pvHasChange: true,

      imgList: [],
      uploadingImg: false,
    }
  },
  computed: {
    ...mapState('chat', [
      'accid',
      'token',
      'ROLE',
      'role',
      'expressionTable',
      'giftTable',
      'emoticonTable',
      'onlineMemberNum',
    ]),
    ...mapState('app', {
      userinfo: state => state.userinfo,
    }),
    tabsDisplay () {
      const STATECONSTANT = {
        // 预告
        2: ['curriculum'],
        // 直播中
        3: ['chat', 'online', 'curriculum', 'forbidden'],
        // 结束
        4: ['chat', 'online', 'curriculum'],
      }
      let result = STATECONSTANT[this.course.state]
      if (!this.course.chatGroupOpenFlag) {
        result = ['curriculum']
      }
      return result || []
    },
  },
  watch: {
    // 对于iView的tabs组件的补丁， 调整tabs的顺序
    tabsDisplay () {
      setTimeout((that) => {
        let orderArray = ['chat', 'online', 'detail', 'material', 'curriculum', 'forbidden']
        let listArray = that.$refs.tabs.navList.splice(0)

        orderArray.forEach((keyword, index) => {
          for (let i = 0, l = listArray.length; i < l; i++) {
            if (listArray[i].name === keyword) {
              that.$refs.tabs.navList.push(listArray[i])
            }
          }
        })
        document.querySelector('#CourseSideBar .ivu-tabs-ink-bar').style.transform = 'translate3d(0px, 0px, 0px)'
        this.tabValue = this.tabsDisplay[0]
      }, 0, this)
    },
  },
  methods: {
    ...mapActions({ saveMsg: 'chat/saveMsg' }),
    // 初始化 Chatroom
    initChatroom () {
      // 初始化敏感词
      this.$store.dispatch('chat/getSensitive').then(data => {
        this.sensitive = data
      })
      // 设置自己的身份
      let isAssistant = false
      let isLecturer = false
      this.course.assistantIds.forEach(accid => {
        if (accid.toUpperCase() === this.accid.toUpperCase()) {
          isAssistant = true
          this.$store.commit('chat/setRole', { role: this.ROLE.ASSISTANT })
        }
      })

      this.course.lecturerIds.forEach(accid => {
        if (accid.toUpperCase() === this.accid.toUpperCase()) {
          isLecturer = true
          this.$store.commit('chat/setRole', { role: this.ROLE.LECTURER })
        }
      })

      if (!isAssistant && !isLecturer) {
        this.$store.commit('chat/setRole', { role: this.ROLE.NONE })
      }

      this.$store
        .dispatch('chat/getChatroomAddress', {
          roomid: this.course.chatGroup,
          accid: this.accid,
        })
        .then(address => {
          chatroomInstance = window.SDK.Chatroom.getInstance({
            appKey: this.$config.appKey,
            account: this.accid,
            token: this.token,
            chatroomCustom: JSON.stringify({
              role: this.role,
              fromAvatar: this.userinfo.avatar || '',
              fromNick: this.userinfo.name || '',
            }),
            chatroomEnterCustom: JSON.stringify({
              fromAvatar: this.userinfo.avatar || '',
              fromNick: this.userinfo.name || '',
              from: this.userinfo.id,
              role: this.role,
            }),
            chatroomId: this.course.chatGroup,
            chatroomAddresses: address,
            onconnect: this.chatroomOnConnect,
            onwillreconnect: () => {
              console.log('<<<< YunXin will reconnect. >>>>')
              this.imIsConnected = false
            },
            ondisconnect: () => {
              console.log('<<<< YunXin is disconnect. >>>>')
              this.imIsConnected = false
            },
            onerror: () => {
              console.log('<<<< YunXin have a error. >>>>')
            },
            onmsgs: msgs => {
              this.msgs.push(...this.handleMsgs(msgs, true, true))
            },
          })
        })
        .catch(() => {
          console.log('<<<< 获取聊天室地址失败 >>>>')
        })
    },
    // Chatroom 连接成功回调
    chatroomOnConnect (res) {
      // 获取得到课程pv数据
      if (this.course.onlineMemberType === 1) { // pv方式
        setInterval(() => { // 每分钟重新从服务器同步一下
          if (this.pvHasChange) {
            this.$store.dispatch('course/getCoursePv', { courseId: this.course.pkid }).then(res => {
              this.pvHasChange = false
            })
          }
        }, 1000)
      }
      this.selfInfo.name = res.member.nick
      this.selfInfo.avatar = res.member.avatar
      this.imIsConnected = true
      this.getHistoryMsgs(true)
      this.getMsgNum()
      if (chatroomInstance) {
        this.getMembersNum()
        this.getMembersList()
      }
    },
    // 发送消息
    sendMsg ({ msgData, resend }) {
      if (chatroomInstance) {
        // sdk方法返回的消息体
        let msgReturn = null
        // 配置发送的参数
        // 如果为重发则增加resend、idClient参数
        switch (msgData.type) {
          case 'text': {
            msgReturn = chatroomInstance.sendText({
              text: msgData.text,
              custom: msgData.custom,
              done: this.sendMsgDone,
              resend: resend,
              idClient: msgData.idClient,
            })
            break
          }
          case 'custom': {
            msgReturn = chatroomInstance.sendCustomMsg({
              content: msgData.content,
              custom: msgData.custom,
              done: this.sendMsgDone,
              resend: resend,
              idClient: msgData.idClient,
            })
            break
          }
          default: {
            return false
          }
        }
        // 增加渲染所需的字段
        msgReturn.fromNick = this.selfInfo.name// 发送者名称
        msgReturn.fromAvatar = this.selfInfo.avatar // 发送者头像
        msgReturn.sending = true // 是否正在发送中的状态
        msgReturn.sendFailed = false // 是否为发送失败

        // 如果为重新发送一条消息 则重置该消息状态
        // 否则直接添加一条消息 && 自动跳转到聊天记录底部
        if (resend) {
          // 倒序查找重置消息状态
          for (let i = this.msgs.length - 1; i + 1; i--) {
            if (this.msgs[i].idClient === msgReturn.idClient) {
              this.msgs[i].sending = true
              this.msg[i].sendFailed = false
            }
          }
        } else {
          this.msgs.push(...this.handleMsgs([msgReturn], true))
          chatBus.$emit('sendNewMsg')
        }
      }
    },
    sendGift (data) {
      let msgReturn = {
        chatroomId: data.roomId,
        idClient: data.msgid_client,
        fromNick: data.fromNick,
        fromAvatar: data.fromAvatar,
        from: data.fromAccount,
        time: data.time,
        type: 'custom',
        content: JSON.parse(data.attach),
        custom: data.ext,
        sending: false,
        sendFailed: false,
      }
      this.msgs.push(...this.handleMsgs([msgReturn], true))
      chatBus.$emit('sendNewMsg')
    },
    sendFile (ev) {
      this.$Message.info({
        content: '图片上传中',
        duration: 2.5,
      })
      this.uploadingImg = true
      chatroomInstance.sendFile({
        type: 'image',
        fileInput: 'xFile',
        uploadprogress: (obj) => {
          // console.log('文件总大小: ' + obj.total + 'bytes')
          // console.log('已经上传的大小: ' + obj.loaded + 'bytes')
          // console.log('上传进度: ' + obj.percentage)
          // console.log('上传进度文本: ' + obj.percentageText)
        },
        uploaddone: (error, file) => {
          // console.log(error)
          // console.log(file)
          // console.log('上传' + (!error ? '成功' : '失败'))
          this.uploadingImg = false
          if (error) {
            this.$Message.error({
              content: '仅支持图片格式',
              duration: 2.5,
            })
          } else {
            ev.target.value = ''
          }
        },
        beforesend: (msgReturn) => {
          // console.log('正在发送p2p image消息, id=' + msgReturn.idClient)
          msgReturn.fromNick = this.selfInfo.name// 发送者名称
          msgReturn.fromAvatar = this.selfInfo.avatar // 发送者头像
          this.msgs.push(...this.handleMsgs([msgReturn], true))
          chatBus.$emit('sendNewMsg')
          // console.log(this.msgs)
          this.saveMsgToServer(msgReturn)
        },
      })
    },
    // 消息发送完成
    sendMsgDone (err, msg) {
      if (err) {}
      // 倒序查找对应保存的消息体, 并置位sending、sendFailed状态
      for (let i = this.msgs.length - 1; i + 1; i--) {
        if (this.msgs[i].idClient === msg.idClient) {
          // 将消息置位为完成
          this.msgs[i].sending = false
          if (err && err.code !== 13004) { // 禁言显示成功
            // 将消息完成状态置位为失败
            this.msgs[i].sendFailed = true
          } else {
            if (!err) {
              this.saveMsgToServer(msg)
            }
          }
          return true
        }
      }
    },
    // 通知服务器增加一条聊天记录
    saveMsgToServer (msg) {
      // 消息类型字典
      const msgTypeDictionary = {
        text: 1,
        image: 11,
        custom: 100,
      }
      // 解析云信返回值为服务器所需字段
      let {
        fromCustom: ext,
        idClient: msgId,
        chatroomId: roomid,
        type: msgType,
      } = msg
      let attach = ''

      if (msgType === 'text') {
        attach = msg.text
      } else if (msgType === 'custom') {
        attach = msg.content
      } else if (msgType === 'image') {
        attach = msg.file.url
      }
      msgType = msgTypeDictionary[msgType]
      this.saveMsg({ attach, roomid, msgType, ext, msgId })
    },
    // 获取历史消息
    getHistoryMsgs (refresh) {
      return new Promise((resolve, reject) => {
        chatroomInstance.getHistoryMsgs({
          timetag: this.msgs[0] && this.msgs[0].time,
          limit: 50,
          msgTypes: ['text', 'custom', 'image'],
          done: (err, { msgs }) => {
            const DELAY = 300
            if (err) {
              reject(err)
              return
            }

            resolve()

            setTimeout(() => {
              if (refresh) {
                this.msgs = []
              }

              this.msgs.unshift(...this.handleMsgs(msgs))
            }, DELAY)
          },
        })
      })
    },
    // 获取消息总数
    getMsgNum () {
      return this.$store
        .dispatch('chat/getMsgNum', {
          roomid: this.course.chatGroup,
        })
        .then(v => {
          this.msgsNum += v
        })
    },
    // 获取成员列表相关信息：在线人数，成员列表（老师 > 助教 > 房主 > 普通成员）
    getMembersInfo: throttle(
      function () {
        if (chatroomInstance) {
          this.getMembersNum()
          this.getMembersList()
        }
      },
      THROTTLEDELAY,
      THROTTLEMAXDELAY
    ),
    // 获取成员列表相关信息：在线人数
    getMembersNum () {
      chatroomInstance.getChatroom({
        done: (err, { chatroom }) => {
          if (err) {
            this.$store.commit('chat/updateOnlineMemberNum', { onlineMemberNum: chatroom.onlineMemberNum })
            return
          }

          this.$store.commit('chat/updateOnlineMemberNum', { onlineMemberNum: chatroom.onlineMemberNum })
        },
      })
    },
    // 获取禁言用户列表
    getMuteList () {
      this.$store.dispatch('course/getMuteUserList', { roomid: this.course.chatGroup }).then(res => {
        this.muteUserList = res
      })
    },
    // 获取成员列表相关信息：成员列表（老师 > 助教 > 房主 > 普通成员）
    getMembersList () {
      // 获取 老师 + 助教 + 房主（默认最多获取 20 个，以后进行分页查询）
      const p1 = new Promise((resolve, reject) => {
        chatroomInstance.getChatroomMembersInfo({
          accounts: this.accounts,
          done (err, { members }) {
            if (err) {
              reject(err)
              return
            }

            resolve(members)
          },
        })
      })

      const p2 = new Promise((resolve, reject) => {
        chatroomInstance.getChatroomMembers({
          guest: false,
          onlyOnline: true,
          done (err, { members }) {
            if (err) {
              reject(err)
              return
            }

            resolve(members)
          },
        })
      })

      // 获取 游客
      const p3 = new Promise((resolve, reject) => {
        chatroomInstance.getChatroomMembers({
          guest: true,
          done (err, { members }) {
            if (err) {
              reject(err)
              return
            }

            resolve(members)
          },
        })
      })

      Promise.all([p1, p2, p3]).then(([am, bm, cm]) => {
        // 判断当前用户是不是管理员
        if (bm.length > 0) {
          let checkArr = bm.filter(item => {
            return (item.type === 'manager' || item.type === 'owner') && (item.account.toLowerCase() === this.userinfo.id.toLowerCase())
          })
          if (checkArr.length > 0) {
            this.isManager = true
            this.getMuteList()
          } else {
            this.isManager = false
          }
        }

        am = this.handleMembers(am)
        bm = this.handleMembers(bm.concat(cm))
        // 过滤 老师 + 助教 + 房主 中不在线的成员
        am = am.filter(v => v.online)

        this.lastEnterTime = bm.length > 0 ? bm[bm.length - 1].enterTime : 0

        // 过滤 bm 中含有 am 的
        bm = bm.filter(v => {
          return !this.accounts.includes(v.account.toLowerCase())
        })

        // 对 am 进行排序
        am = am.sort((a, b) => b.role - a.role)

        this.members = am.concat(bm)
      })
    },
    // 分页获取成员列表
    getMembersListLimit () {
      return new Promise((resolve, reject) => {
        if (this.lastEnterTime <= 0) {
          reject(new Error('已获取到全部成员'))
          return
        }

        chatroomInstance.getChatroomMembers({
          guest: true,
          time: this.lastEnterTime,
          done: (err, { members }) => {
            const DELAY = 300
            if (err) {
              reject(err)
              return
            }

            resolve()

            members = this.handleMembers(members)

            this.lastEnterTime
              = members.length > 0 ? members[members.length - 1].enterTime : 0

            members = members.filter(v => {
              return !this.accounts.includes(v.account.toUpperCase())
            })

            setTimeout(() => {
              this.members.push(...members)
            }, DELAY)
          },
        })
      })
    },
    // 处理成员信息
    handleMembers (members) {
      return members.map(
        ({ account, avatar, custom, enterTime, nick, online, gaged }) => {
          try {
            custom = JSON.parse(custom)

            if (typeof custom !== 'object') {
              custom = {}
            }

            if (custom.role === undefined) {
              custom.role = this.ROLE.NONE
            }
          } catch (e) {
            custom = {
              role: this.ROLE.NONE,
            }
          }

          return {
            account,
            avatar,
            nick,
            online,
            enterTime,
            enterTimeString: dateStringFrom('hh:mm:ss', enterTime),
            role: custom.role,
            gaged,
          }
        }
      )
    },
    // 处理聊天消息
    handleMsgs (msgs, recordNum, newMsg) {
      // 这里传入的 msgs 数组是按时间递减的，返回时应当翻转

      const result = []
      const accidToLowerCase = this.accid.toLowerCase() // 暂存 accid.toUpperCase()
      const needShowMsgs = ['text', 'custom.expression', 'custom.gift', 'image'] // 需要放入聊天室的消息（放入 msgs 数组）
      const needChatMsgsNumIncreasing = [
        'text',
        'custom.expression',
        'custom.gift',
        'image',
      ] // 需要聊天室消息数量递增的 type 数组
      let chatMsgsNumIncreasingValue = 0
      msgs.forEach(
        ({
          chatroomId, // 聊天室 ID
          idClient, // SDK 生成的消息 ID
          from, // 发送者 ID
          fromNick, // 发送者名称
          fromAvatar, // 发送者头像
          time, // 发送时间
          type, // 消息类型
          text, // type is 'text'，消息内容
          content, // type is 'custom'，消息内容
          attach = {}, // type is 'notification'，消息内容
          custom, // 扩展消息
          sending, // 消息是否发送中
          sendFailed, // 消息是否发送失败
          flow,
          file,
          fromCustom, // 来自用户的信息
        }) => {
          // 处理扩展消息
          try {
            if (custom) {
              custom = JSON.parse(custom)
            }
          } catch (e) {}

          let tagMixed = false // 文本消息中是否有表情混合(当有超链接时也使用这个标识位)
          let tagResolvedMsg = null // 处理过表情之后的文本消息
          // 如果为双师系统
          // 判断自身身份，如果为老师或助教，则不做处理
          // 根据特殊类型进行的一些特殊处理
          if (type === 'custom') {
            if (!content) {
              return
            }

            try {
              content = JSON.parse(content)
            } catch (e) {
              return
            }

            type += `.${content.type}`
          }

          // 消息验证
          switch (type) {
            case 'text':
              if (!text) {
                return
              }
              break
            case 'custom.expression':
              content.src = this.expressionTable[content.id]

              if (!content.src) {
                return
              }
              break
            case 'custom.gift':
              const nowGiftObject = this.giftTable[content.id]

              if (!nowGiftObject) {
                return
              }

              content.name = nowGiftObject.name
              content.src = nowGiftObject.src
              break
            default:
              break
          }

          if (recordNum && needChatMsgsNumIncreasing.includes(type)) {
            chatMsgsNumIncreasingValue++
          }

          // 消息处理
          switch (type) {
            // 处理文本消息，判断是否需要以v-html形式渲染
            case 'text':
              // 预处理表情，并以随机字符替换，避免在匹配超链接时被误匹配
              let { resultText, table } = this.preReplaceEmoticonText(text)
              text = resultText
              // 敏感词过滤
              if (flow !== 'out' && this.accid.toLowerCase() !== from) {
                // 可以发送，但不能接收
                let isSensitive = false
                for (let i = this.sensitive.length - 1; i >= 0; i--) {
                  if (text.indexOf(this.sensitive[i]) > -1) {
                    isSensitive = true
                    break
                  }
                }
                if (isSensitive) {
                  return
                }
              }

              // 进行超链接的匹配 同时转义尖括号
              let handledString = handleUrlString(text)
              tagMixed = handledString !== text
              tagResolvedMsg = handledString

              // 处理、替换表情tag
              let tableEntries = Object.entries(table)
              if (tableEntries.length) {
                tagMixed = true
                tableEntries.forEach(([randomString, imgTag]) => {
                  tagResolvedMsg = tagResolvedMsg.replace(new RegExp(randomString, 'g'), imgTag)
                })
              }

              break
            case 'custom.exporession':
              break
            case 'custom.gift':
              break
            case 'notification':
              // 处理进入离开事件
              // if (attach.type === 'memberEnter') {
              //   // 列表增加人数
              //   let member = attach.custom ? JSON.parse(attach.custom) : {}
              //   if (from.toUpperCase() !== this.userinfo.id.toUpperCase()) {
              //     this.members.push(...this.handleMembers([{
              //       account: from,
              //       avatar: member.fromAvatar,
              //       custom: JSON.stringify(member),
              //       enterTime: time,
              //       nick: member.fromNick,
              //     }]))
              //   }
              //   // 排序
              //   this.members.sort((a, b) => b.role - a.role)
              //   this.$store.commit('chat/updateOnlineMemberNum', { onlineMemberNum: this.members.length })
              // } else if (attach.type === 'memberExit') {
              //   // 减少人数
              //   this.members = this.members.filter(member => member.account !== from)
              //   this.$store.commit('chat/updateOnlineMemberNum', { onlineMemberNum: this.members.length })
              // }
              if (attach.type === 'memberEnter') {
                // 当有连接进来发送请求累计pv
                this.pvHasChange = true
                this.getMembersInfo()
              } else if (attach.type === 'memberExit') { // 离开直接移除
                this.members = this.members.filter(m => m.account !== attach.from)
                this.$store.commit('chat/updateOnlineMemberNum', { onlineMemberNum: this.onlineMemberNum - 1 })
              }
              break
            default:
              break
          }

          if (needShowMsgs.includes(type)) {
            result.unshift({
              chatroomId,
              idClient,
              from,
              fromNick,
              fromAvatar,
              time,
              timeString: dateStringFrom('hh:mm:ss', time),
              type,
              text,
              content,
              attach,
              custom,
              sending,
              sendFailed,
              isAtMe:
                custom
                && Array.isArray(custom.remoteExt)
                && custom.remoteExt.includes(accidToLowerCase),
              role: custom && custom.role,
              isSelf: from.toLowerCase() === accidToLowerCase,
              tagMixed,
              tagResolvedMsg,
              file,
            })
          }
        }
      )

      if (chatMsgsNumIncreasingValue > 0) {
        this.msgsNum += chatMsgsNumIncreasingValue
        // 只有接受到用户发送的真正消息时才进行通知
        newMsg && chatBus.$emit('receiveNewMsg')
      }

      return result
    },
    /**
     * replace emoticon key word to random string
     * return random string with emoticon table
     * @param {String} msgText
     * @returns {Object}
     * {
     *  resultText,
     *  table
     * }
     * return null if non-word matched
     */
    preReplaceEmoticonText (msgText) {
      let table = {}
      let result = Object.entries(this.emoticonTable).reduce((string, map) => {
        let [key, value] = map
        let reKeyWord = '(\\' + key.slice(0, -1) + '\\' + key.slice(-1) + ')'
        let re = new RegExp(reKeyWord, 'g')
        // 以随机数作为随机字符替换表情关键字 添加非常规字符'ζ'作为前后分隔
        let randomString = 'ζ' + Math.random() + 'ζ'
        randomString = randomString.replace('.', '') // 移除.  避免.操作符在正则中的影响
        let resolvedStr = string.replace(re, randomString)
        if (string !== resolvedStr) {
          table[randomString] = `<img src="/img/expression/${value}"/>`
        }
        return resolvedStr
      }, msgText)
      return {
        table: table,
        resultText: result,
      }
    },
    preview (url) {
      // this.previewImage = url
      // this.isPreviewShow = true
      this.imgList = [url]
      console.log(this.imgList, this.$viewer)
      this.$viewer.show()
    },
    closePreview () {
      this.isPreviewShow = false
      this.previewImage = ''
    },
    forbidden (v) {
      const param = {}
      param.roomid = this.course.chatGroup
      param.operator = this.userinfo.id
      param.target = v.from || v.account
      param.opt = -2
      param.optvalue = true
      this.$store.dispatch('course/setMuteUser', param).then(res => {
        this.$Message.success({
          content: '操作成功',
        })
        this.getMuteList()
        this.getMembersList()
      }).catch(err => {
        this.$Message.error({
          content: err.msg,
        })
      })
    },
    cancelForbidden (v) {
      const param = {}
      param.roomid = this.course.chatGroup
      param.operator = this.userinfo.id
      param.target = v.accid || v.account
      param.opt = -2
      param.optvalue = false
      this.$store.dispatch('course/setMuteUser', param).then(res => {
        this.$Message.success({
          content: '操作成功',
        })
        this.getMuteList()
        this.getMembersList()
      }).catch(err => {
        this.$Message.error({
          content: err.msg,
        })
      })
    },
    changeCourseProps (obj) {
      this.$emit('changeCourseProps', obj)
    },
    initViewer (viewer) {
      this.$viewer = viewer
    },
  },
  created () {
    chatBus.$once('initChatroom', this.initChatroom)
  },
  beforeDestroy () {
    if (chatroomInstance) {
      chatroomInstance.disconnect()
      chatroomInstance = null
    }
    // 离开页面的时候移除事件
    chatBus.$off('initChatroom')
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/sidebar.scss';
#CourseSideBar {
  .chat-wrap {
    margin-top: 64px;
    height: calc(100% - 64px);
    display: flex;
    flex-direction: column;
  }
}
.preview {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 640px;
  z-index: 100;
  box-shadow: rgb(221, 221, 221) 0px 1px 5px;
  background: #fff;
  .close {
    position: absolute;
    top: -12px;
    left: -12px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    background: #000;
    .ibang-close {
      color: #fff
    }
  }
  .img-wrapper{
    overflow: auto;
    max-height:90vh;
  }
}
</style>
